<template>
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path
            d="M1.95312 0.332031L0.953125 1.33203L5 5.37891L9.04688 1.33203L8.04688 0.332031L5 3.37891L1.95312 0.332031Z"
            fill="currentColor"
        />
    </svg>
</template>
